import React, { memo } from 'react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing-cta-button')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative pt-8 pb-10 md:pt-10 md:pb-14 px-4 overflow-hidden bg-cream" data-id="element-74">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-75">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-soft-rose opacity-50 blur-3xl" data-id="element-76"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 rounded-full bg-deep-rose opacity-10 blur-3xl" data-id="element-77"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-78">
        <span className="text-deep-rose font-semibold tracking-wider uppercase text-xs md:text-sm mb-3 block" data-id="element-79">
          Alquimia del Linaje: El Despertar del Útero y el Corazón
        </span>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight" data-id="element-80">
          ¿Sentís que cargás un peso que no es tuyo?
        </h1>

        {/* Product Image */}
        <div className="mb-4 flex justify-center" data-id="element-81">
          <img src="https://cdn.magicpatterns.com/uploads/ddWbadfbHvQJsfmQZLDLVE/Gemini_Generated_Image_4a98x44a98x44a98.png" alt="Alquimia del Linaje - 2 Tomos y Tablet" className="rounded-xl shadow-lg max-w-full h-auto md:max-w-2xl object-cover" data-id="element-82" />
        </div>

        <h2 className="text-lg md:text-xl font-body font-light text-warm-brown mb-4 leading-relaxed" data-id="element-83">
          Descubrí cómo sanar el dolor de tu linaje femenino, liberar las
          memorias guardadas en tu útero y corazón… y convertirte en la mujer
          libre que tus ancestras soñaron ser.
        </h2>

        <p className="text-warm-brown/80 mb-6 italic text-[12px]" data-id="element-84">
          El método completo en 2 Tomos + 4 Bonos exclusivos para mujeres que
          están listas para que la cadena de dolor termine con ellas.
        </p>

        <div className="flex flex-col items-center space-y-3" data-id="element-85">
          <Button onClick={scrollToPricing} className="text-lg md:text-xl px-8 py-4" data-id="element-86">
            🌹 QUIERO SANAR MI LINAJE AHORA
          </Button>

          <div className="text-xs md:text-sm text-warm-brown/70 space-y-1 mt-2" data-id="element-87">
            <p data-id="element-88">Accedo a los 2 Tomos + 4 Bonos por solo $19.999</p>
            <p className="flex items-center justify-center gap-2 md:gap-3 mt-1" data-id="element-89">
              <span data-id="element-90">🔒 Pago seguro</span>
              <span data-id="element-91">•</span>
              <span data-id="element-92">✉️ Acceso inmediato</span>
              <span data-id="element-93">•</span>
              <span data-id="element-94">🛡️ Garantía 7 días</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}